import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import {finalize} from 'rxjs/operators';

import { SLEntityVersion } from './entity';
import { SLEntityService } from './entity.service';
import { NotifierService } from '../../ui';
import { FormControl, Validators } from '@angular/forms';
import { isEmpty } from 'lodash';

type ViewMode = 'form' | 'searching';

@Component({
  templateUrl: './entity-version-verify.component.html',
})
export class SLEntityVersionVerifyComponent implements OnInit {

  entity: SLEntityVersion = undefined;

  showHidden: boolean = true;

  mode: ViewMode = 'form'

  signature: FormControl

  @ViewChild('signatureInput')
  signatureInput: ElementRef

  constructor(
    private entityService: SLEntityService,
    private notifier: NotifierService,
  ) { }

  ngOnInit() {
    // signature
    this.signature = new FormControl('', [
      Validators.required
    ]);

    // Focus signature input
    this.signatureInput.nativeElement.focus();
  }

  submit() {
    
    if (!this.valid) {
      return;
    }

    this.mode = 'searching';
    this.entity = null;

    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    this.entityService
      .entityVersionBySignature(this.signature.value).pipe(
      finalize(onComplete))
      .subscribe((entity) => {
        this.entity = entity;

        this.mode = 'form';
      }, (error) => {
        this.mode = 'form';
        this.entity = undefined;
      });
  }

  get valid() {
    if (this.mode !== 'form') {
      return false;
    }

    let signature = this.signature.value;

    if (isEmpty(signature) || isEmpty(signature.trim())) {
      return false;
    }
    
    return true;
  }
}
